import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { toggleMenuOpen } from "@client/widgets/Header/actions";
import { isMenuOpenSelector } from "@client/widgets/Header/selectors";
import Component, { type HeaderMainMenuToggleActionProps, type HeaderMainMenuToggleMapProps } from "./component";
import { makeIsVisibleSelector } from "./selectors";

export interface HeaderMenuToggleContainerProps {
  isLeft: boolean;
}

const INVISIBLE_PROPS: HeaderMainMenuToggleMapProps & WithIsVisibleHOCProps = {
  className: "",
  isOpen: false,
  isVisible: false
};

export const makeMapStateToProps = () => {
  const isVisibleSelector = makeIsVisibleSelector();

  return (
    state: AppState,
    props: HeaderMenuToggleContainerProps
  ): HeaderMainMenuToggleMapProps & WithIsVisibleHOCProps => {
    const isVisible = isVisibleSelector(state, props);
    if (!isVisible) return INVISIBLE_PROPS;

    return {
      className: "wsc_menu_toggle",
      isOpen: isMenuOpenSelector(state),
      isVisible: true
    };
  };
};

const mapDispatchToProps = (dispatch: any): HeaderMainMenuToggleActionProps => ({
  onClick: () => dispatch(toggleMenuOpen())
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
